import type { AdminNotificationListItemResponse } from "../../../types/adminTypes";
import { formatDate } from "../../../utils/DateUtils";
import Button from "../../ui/Button/Button";
import AdminPillBadge from "../ui/AdminPillBadge";

type AdminNotificationsTableRowProps = {
  notification: AdminNotificationListItemResponse;
  onView: (notification: AdminNotificationListItemResponse) => void;
};

const statusTone: Record<AdminNotificationListItemResponse["status"], "warning" | "success" | "danger"> = {
  PENDING: "warning",
  SENT: "success",
  FAILED: "danger",
};

const AdminNotificationsTableRow = ({ notification, onView }: AdminNotificationsTableRowProps) => {
  return (
    <tr className="align-top">
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p className="font-semibold">{notification.recipientEmail}</p>
          <p className="text-myteengig-text-muted">{notification.subject}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <AdminPillBadge>{notification.type}</AdminPillBadge>
          <p className="text-xs text-myteengig-text-muted">{notification.channel}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <AdminPillBadge tone={statusTone[notification.status]}>{notification.status}</AdminPillBadge>
          <p className="text-xs text-myteengig-text-muted">{notification.lastError ? "Has error" : "No error"}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p>{notification.attemptCount}</p>
          {notification.lastError ? <p className="line-clamp-2 text-xs text-myteengig-text-muted">{notification.lastError}</p> : null}
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDate(notification.availableAt)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDate(notification.createdAt)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <Button variant="outline" size="sm" onClick={() => onView(notification)}>
          View
        </Button>
      </td>
    </tr>
  );
};

export default AdminNotificationsTableRow;
